import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { RouterLink } from '@angular/router';
import { WeatherDescriptionIconNamePipe } from '../../modules/weather-pipes';
import { WeatherService } from '../../services/weather.service';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-application-toolbar-content-icon-weather',
    imports: [
    AsyncPipe,
    RouterLink,
    MatButtonModule,
    WeatherDescriptionIconNamePipe
],
    templateUrl: './application-toolbar-content-icon-weather.component.html',
    styleUrl: './application-toolbar-content-icon-weather.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ApplicationToolbarContentIconWeatherComponent {
  readonly weatherService = inject(WeatherService);
}
